import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog__header flex flex-column" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "upload-wrapper flex relative text-center align-items-center justify-content-center w-full" }
const _hoisted_4 = {
  key: 1,
  class: "upload-wrapper__file-list flex w-full h-full list-none absolute left-0 align-items-center"
}
const _hoisted_5 = {
  key: 0,
  class: "field w-full description-field required mt-4"
}
const _hoisted_6 = {
  key: 1,
  class: "field w-full description-field required mt-4"
}

import { computed, ref, toRefs, onMounted } from 'vue';
import FileUpload from 'primevue/fileupload';
import FilePreview from './components/FilePreview.vue';
import Dialog from 'primevue/dialog';
import useFileList from '@/composables/useFileList';
import { EMIT } from '@/enum';
import { FileInterface } from '@/types';
import { useDocumentsStore, useOrganizationStore, useBillingStore, useOrganizationDocumentStore } from '@/store';

interface PropsInterface {
  title: string;
  className?: string | null;
  loading?: boolean;
  billing?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddOrganizationDocumentModal',
  props: {
    title: {},
    className: {},
    loading: { type: Boolean },
    billing: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const documentStore = useDocumentsStore();
const billingStore = useBillingStore();
const organizationStore = useOrganizationStore();
const organizationDocumentStore = useOrganizationDocumentStore();
const { title, billing } = toRefs(props);
const { files, addFiles, removeFile } = useFileList();
const selectedInvoice = ref<string>();
const description = ref<string>('');
const invoices = ref<string[]>([]);
const modalVisible = ref(true);

const hasError = computed(() => !!documentStore.error);
onMounted(() => {
  getInvoiceNumbers();
});

const getInvoiceNumbers = async () => {
  await billingStore.getAllInvoices({ search: organizationStore.organization.id.toString() });
  invoices.value = billingStore.invoices
    ?.filter((invoice) => invoice.organization_id == organizationStore.organization.id)
    .map((invoice) => invoice.invoice_number) as string[];
};

/**
 * create the form data for proper POST
 * of blob documents
 */
const createForm = (file: FileInterface) => {
  const formData = new FormData();
  formData.append('document', file.file as Blob);
  formData.append('name', file.name);
  if (billing.value) {
    formData.append('invoice_number', selectedInvoice.value as string);
  } else {
    formData.append('description', description.value);
  }

  return formData;
};

/**
 * emit the SAVE to the parent with the files to upload,
 * reset the array and hide the modal
 * note: this only handles ONE file upload
 */
const save = async () => {
  const file: FileInterface = [...files.value][0];
  const formData = createForm(file);
  if (billing.value) {
    await organizationDocumentStore.uploadBillingDocument(organizationStore.organization.id, formData);
  } else {
    await organizationDocumentStore.uploadGeneralDocument(organizationStore.organization.id, formData);
  }

  if (!hasError.value) {
    modalVisible.value = false;
    emit(EMIT.SAVE);
  } else {
    removeFile(file);
  }
};

/**
 * on dropping the file to the uploader add to file storage
 */
const onDrop = (e: Event) => addFiles(e.files);

/**
 * get the form items and make sure theyre completed
 * before enabling the save button
 * @returns boolean
 */
const formDisabled = computed<boolean>(() => {
  const invoiceSelected = selectedInvoice.value || !billing.value;
  const descriptionFilled = description.value || billing.value;
  return !invoiceSelected || !descriptionFilled || ![...files.value].length;
});

const cancel = () => {
  removeError();
  emit(EMIT.CANCEL);
  modalVisible.value = false;
};

const removeError = () => (documentStore.error = undefined);

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container add-document__modal",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          class: "m-0",
          textContent: _toDisplayString(props.title)
        }, null, 8, _hoisted_2)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: _unref(title),
        disabled: formDisabled.value,
        onClick: save
      }, null, 8, ["text", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (!_unref(files).length)
          ? (_openBlock(), _createBlock(_unref(FileUpload), {
              key: 0,
              "custom-upload": true,
              class: "upload relative",
              "choose-label": "Choose file",
              accept: ".pdf, .doc, .docx, .xls, .xlsx",
              "invalid-file-type-message": 'Sorry, this file type is not supported. Please select a supported file type: {1}',
              auto: true,
              mode: "advanced",
              "show-cancel-button": false,
              "show-upload-button": false,
              "max-file-size": 100000000,
              "invalid-file-size-message": "Error: This file exceeds the max file size allowed.",
              onUploader: onDrop
            }, {
              empty: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("p", { class: "uploader-text font-bold text-base mt-2" }, [
                  _createElementVNode("span", { class: "underline cursor-pointer" }, "Choose File"),
                  _createTextVNode(" or drag and drop here ")
                ], -1),
                _createElementVNode("p", { class: "acceptable-files-text" }, "Allowed types: .pdf, .doc, .docx, .xls, .xlsx", -1),
                _createElementVNode("p", { class: "acceptable-files-text" }, "Max File size: 100MB", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (file) => {
                return (_openBlock(), _createBlock(FilePreview, {
                  key: file.id,
                  class: "w-full flex text-left align-items-center",
                  file: file,
                  tag: "li",
                  onRemove: _unref(removeFile)
                }, null, 8, ["file", "onRemove"]))
              }), 128))
            ]))
      ]),
      (_unref(billing))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "invoice_number" }, "Invoice Number", -1)),
            _createVNode(_component_Dropdown, {
              id: "invoice_number",
              modelValue: selectedInvoice.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedInvoice).value = $event)),
              options: invoices.value,
              required: "",
              placeholder: "Select an Invoice Number",
              class: "description-field__input w-full"
            }, null, 8, ["modelValue", "options"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "description" }, "Description", -1)),
            _createVNode(_component_InputText, {
              id: "description",
              modelValue: description.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
              required: "",
              class: "description-field__input w-full",
              name: "description"
            }, null, 8, ["modelValue"])
          ]))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})